import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import RankingSection from '@/pages/home/components/RankingSection';
import ViralSection from '@/pages/home/components/ViralSection';
import ClassicSection from '@/pages/home/components/ClassicSection';
import EditorPicks from '@/pages/home/components/EditorPicks';
import InsightsSection from '@/pages/home/components/InsightsSection';
import GuideSection from '@/pages/home/components/GuideSection';
import FaqSection from '@/pages/home/components/FaqSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <RankingSection />
        <ViralSection />
        <ClassicSection />
        <EditorPicks />
        <InsightsSection />
        <GuideSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}